<form [formGroup]="receiptForm" (ngSubmit)="onSubmit()" novalidate>
  <div class="grid">
    <div class="col-12 md:col-6 lg:col-3">
      <div class="p-field">
        <label for="sellerBRN" class="required"
          >Seller BRN (Business Registration Number)</label
        >
        <input
          id="sellerBRN"
          formControlName="sellerBRN"
          pInputText
          [disabled]="isFormSubmitted"
        />
        @if (f['sellerBRN'].touched && f['sellerBRN'].invalid) {
          <div class="p-error">
            @if (f['sellerBRN'].errors?.['required']) {
              <span>Seller BRN is required</span>
            }
            @if (f['sellerBRN'].errors?.['maxLength']) {
              <span>Please provide valid Seller BRN (max 20 characters)</span>
            }
            @if (f['sellerBRN'].errors?.['invalidCharacters']) {
              <span>Special characters are not allowed</span>
            }
          </div>
        }
      </div>
    </div>

    <div class="col-12 md:col-6 lg:col-3">
      <div class="p-field">
        <label for="receiptType" class="required">Receipt Type</label>
        <p-select
          id="receiptType"
          formControlName="receiptType"
          [options]="receiptTypes"
          optionLabel="name"
          optionValue="value"
          [class.is-invalid]="
            f['receiptType'].touched && f['receiptType'].invalid
          "
          [disabled]="isFormSubmitted"
        ></p-select>
        @if (f['receiptType'].touched && f['receiptType'].invalid) {
          <div class="p-error">
            Receipt Type is required
          </div>
        }
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-3">
      <div class="p-field">
        <label for="receiptNumber" class="required">Receipt Number</label>
        <input
          id="receiptNumber"
          formControlName="receiptNumber"
          pInputText
          [disabled]="isFormSubmitted"
        />
        @if (f['receiptNumber'].touched && f['receiptNumber'].invalid) {
          <div class="p-error">
            @if (f['receiptNumber'].errors?.['required']) {
              <span>Receipt number is required</span>
            }
            @if (f['receiptNumber'].errors?.['maxLength']) {
              <span>Please provide valid Receipt Number (max 50 characters)</span>
            }
          </div>
        }
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-3">
      <div class="p-field">
        <label for="receiptDate" class="required">Receipt Date</label>
        <p-datepicker
          id="receiptDate"
          formControlName="receiptDate"
          placeholder="yyyy-mm-dd"
          dateFormat="yy-mm-dd"
          [showTime]="false"
          [disabled]="isFormSubmitted"
        ></p-datepicker>

        @if (f['receiptDate'].touched && f['receiptDate'].invalid) {
          <div class="p-error">
            @if (f['receiptDate'].errors?.['required']) {
              <span>Receipt Date is required</span>
            }
            @if (f['receiptDate'].errors?.['invalidFormat']) {
              <span>Please provide receipt date in YYYY-MM-DD format</span>
            }
            @if (f['receiptDate'].errors?.['futureDate']) {
              <span>Future Date not allowed</span>
            }
            @if (f['receiptDate'].errors?.['invalidMonth']) {
              <span>Please provide receipt of current month only</span>
            }
          </div>
        }
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-3">
      <div class="p-field">
        <label for="receiptTotal" class="required"
          >Receipt Total Payable Amount</label
        >
        <input
          id="receiptTotal"
          formControlName="receiptTotal"
          pInputText
          [disabled]="isFormSubmitted"
        />
        @if (f['receiptTotal'].touched && f['receiptTotal'].invalid) {
          <div class="p-error">
            @if (f['receiptTotal'].errors?.['required']) {
              <span>Receipt Total Payable Amount is required</span>
            }
            @if (f['receiptTotal'].errors?.['invalidReceiptTotal']) {
              <span>Please provide valid Total Payable amount (max 30 characters)</span>
            }
          </div>
        }
      </div>
    </div>
    @if (!isFormSubmitted) {
      <div class="col-12 md:col-6 lg:col-3">
        <div class="captcha-wrapper" [class.mt-10]="!captchaImage">
          @if (captchaImage) {
            <div class="captcha-image-container">
              <img
                [src]="captchaImage"
                alt="CAPTCHA Image"
                class="captcha-image"
              />
            </div>
          }

        <button
          pButton
          type="button"
          class="ey-button-dark mt-0 refresh-button"
          aria-label="Refresh CAPTCHA"
          (click)="refreshCaptcha()"
        >
          <i class="pi pi-refresh" aria-hidden="true"></i>
        </button>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <div class="p-field">
          @if (this.disablePTTesting == null) {
            <label for="receiptTotal" class="required">Enter Captcha</label>
          }
          @if (this.disablePTTesting != null) {
            <label for="receiptTotal">Enter Captcha</label>
          }
        <input
          id="receiptTotal"
          formControlName="captcha"
          [class.is-invalid]="f['captcha'].touched && f['captcha'].invalid"
          pInputText
          [disabled]="isFormSubmitted"
        />
          @if (f['captcha'].touched && f['captcha'].invalid) {
            <div class="p-error">
              <!-- Required error -->
              @if (f['captcha'].errors?.['required']) {
                <span>Captcha is required</span>
              }
              <!-- Incorrect CAPTCHA error -->
              @if (f['captcha'].errors?.['incorrect']) {
                <span>{{ validationMessage }}</span>
              }
            </div>
          }
        </div>
      </div>
    }
    <!-- <div class="col-12 md:col-6 lg:col-3"></div> -->
    @if (!isFormSubmitted) {
      <div class="p-field p-col-12">
        <div class="button-container">
          <button
            type="submit"
            class="ey-button-dark me-2 mt-0"
            [disabled]="receiptForm.invalid"
            [pTooltip]="receiptForm.invalid ? '' : 'Click to initiate a search for the receipt.'"
            tooltipPosition="right"
          >Search for Receipt</button>
        </div>
      </div>
    }
  </div>
</form>
